import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getProducts = (category) =>
  axios.get(`${API}/products`, { params: category && category !== "All" ? { category } : {} }).then((r) => r.data);

export const getConfig = () => axios.get(`${API}/config`).then((r) => r.data);

export const placeOrder = (payload) => axios.post(`${API}/orders`, payload).then((r) => r.data);

export const createRazorpayOrder = (orderId) =>
  axios.post(`${API}/payments/razorpay-order`, { order_id: orderId }).then((r) => r.data);

export const verifyPayment = (payload) => axios.post(`${API}/payments/verify`, payload).then((r) => r.data);

export const sendEnquiry = (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data);

export const trackOrder = (order_no, phone) =>
  axios.post(`${API}/orders/track`, { order_no, phone }).then((r) => r.data);

export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data);

const authHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const adminGetOrders = (token) => axios.get(`${API}/admin/orders`, authHeaders(token)).then((r) => r.data);
export const adminGetEnquiries = (token) => axios.get(`${API}/admin/enquiries`, authHeaders(token)).then((r) => r.data);
export const adminGetStats = (token) => axios.get(`${API}/admin/stats`, authHeaders(token)).then((r) => r.data);
export const adminUpdateOrderStatus = (token, orderId, status) =>
  axios.patch(`${API}/admin/orders/${orderId}`, { status }, authHeaders(token)).then((r) => r.data);

export const adminCreateProduct = (token, payload) =>
  axios.post(`${API}/admin/products`, payload, authHeaders(token)).then((r) => r.data);

export const adminUpdateProduct = (token, slug, payload) =>
  axios.put(`${API}/admin/products/${slug}`, payload, authHeaders(token)).then((r) => r.data);

export const adminDeleteProduct = (token, slug) =>
  axios.delete(`${API}/admin/products/${slug}`, authHeaders(token)).then((r) => r.data);

export const adminUploadImage = (token, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}/admin/upload`, fd, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => ({ ...r.data, url: `${process.env.REACT_APP_BACKEND_URL}${r.data.url}` }));
};

export const registerCustomer = (payload) => axios.post(`${API}/auth/register`, payload).then((r) => r.data);
export const loginCustomer = (payload) => axios.post(`${API}/auth/login`, payload).then((r) => r.data);
export const getMe = (token) => axios.get(`${API}/auth/me`, authHeaders(token)).then((r) => r.data);
export const getMyOrders = (token) => axios.get(`${API}/auth/orders`, authHeaders(token)).then((r) => r.data);
export const saveAddress = (token, payload) =>
  axios.post(`${API}/auth/addresses`, payload, authHeaders(token)).then((r) => r.data);
export const deleteAddress = (token, id) =>
  axios.delete(`${API}/auth/addresses/${id}`, authHeaders(token)).then((r) => r.data);
export const validateCoupon = (code, subtotal, mrpSubtotal) =>
  axios.post(`${API}/coupons/validate`, { code, subtotal, mrp_subtotal: mrpSubtotal }).then((r) => r.data);

export const adminGetCoupons = (token) => axios.get(`${API}/admin/coupons`, authHeaders(token)).then((r) => r.data);
export const adminCreateCoupon = (token, payload) =>
  axios.post(`${API}/admin/coupons`, payload, authHeaders(token)).then((r) => r.data);
export const adminToggleCoupon = (token, id, active) =>
  axios.patch(`${API}/admin/coupons/${id}`, { active }, authHeaders(token)).then((r) => r.data);

export const submitReview = (payload) => axios.post(`${API}/reviews`, payload).then((r) => r.data);
export const getProductReviews = (slug) => axios.get(`${API}/products/${slug}/reviews`).then((r) => r.data);
export const adminGetReviews = (token) => axios.get(`${API}/admin/reviews`, authHeaders(token)).then((r) => r.data);
export const adminApproveReview = (token, id, approved) =>
  axios.patch(`${API}/admin/reviews/${id}`, { approved }, authHeaders(token)).then((r) => r.data);
export const adminDeleteReview = (token, id) =>
  axios.delete(`${API}/admin/reviews/${id}`, authHeaders(token)).then((r) => r.data);

const downloadBlob = (data, filename) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const downloadInvoice = async (orderNo, phone) => {
  const r = await axios.post(`${API}/orders/invoice`, { order_no: orderNo, phone }, { responseType: "blob" });
  downloadBlob(r.data, `Classina-Invoice-${orderNo}.pdf`);
};

export const adminDownloadInvoice = async (token, orderId, orderNo) => {
  const r = await axios.get(`${API}/admin/orders/${orderId}/invoice`, { ...authHeaders(token), responseType: "blob" });
  downloadBlob(r.data, `Classina-Invoice-${orderNo}.pdf`);
};

export const adminDownloadPriceList = async (token) => {
  const r = await axios.get(`${API}/admin/price-list.pdf`, { ...authHeaders(token), responseType: "blob" });
  downloadBlob(r.data, "Classina-Price-List.pdf");
};

export const adminGetPriceList = (token) => axios.get(`${API}/admin/price-list`, authHeaders(token)).then((r) => r.data);

export const adminUpdatePriceList = (token, payload) =>
  axios.put(`${API}/admin/price-list`, payload, authHeaders(token)).then((r) => r.data);

export const checkDelivery = (pincode) => axios.post(`${API}/delivery/check`, { pincode }).then((r) => r.data);

export const getProduct = (slug) => axios.get(`${API}/products/${slug}`).then((r) => r.data);

export const getOffers = () => axios.get(`${API}/offers`).then((r) => r.data);

export const requestBuyNow = () => window.dispatchEvent(new Event("classina:buy-now"));

export const recordView = (slug) => {
  try {
    const list = JSON.parse(localStorage.getItem("classina_recent") || "[]").filter((s) => s !== slug);
    list.unshift(slug);
    localStorage.setItem("classina_recent", JSON.stringify(list.slice(0, 8)));
    window.dispatchEvent(new Event("classina:recent"));
  } catch {
    /* storage unavailable */
  }
};

export const getRecentSlugs = () => {
  try {
    return JSON.parse(localStorage.getItem("classina_recent") || "[]");
  } catch {
    return [];
  }
};

export const getCategories = () => axios.get(`${API}/categories`).then((r) => r.data);
export const adminCreateCategory = (token, payload) =>
  axios.post(`${API}/admin/categories`, payload, authHeaders(token)).then((r) => r.data);
export const adminUpdateCategory = (token, id, payload) =>
  axios.put(`${API}/admin/categories/${id}`, payload, authHeaders(token)).then((r) => r.data);
export const adminDeleteCategory = (token, id) =>
  axios.delete(`${API}/admin/categories/${id}`, authHeaders(token)).then((r) => r.data);

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
};

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const FREE_SHIPPING_THRESHOLD = 499;
export const SHIPPING_FEE = 49;

let settingsCache = null;
export const getSettings = () => {
  if (settingsCache) return Promise.resolve(settingsCache);
  return axios.get(`${API}/settings`).then((r) => {
    settingsCache = r.data;
    return r.data;
  });
};

export const adminUpdateSettings = (token, payload) =>
  axios.put(`${API}/admin/settings`, payload, authHeaders(token)).then((r) => {
    settingsCache = r.data;
    return r.data;
  });

export const adminGetProducts = (token) => axios.get(`${API}/admin/products`, authHeaders(token)).then((r) => r.data);

export const adminCloneProduct = (token, slug) =>
  axios.post(`${API}/admin/products/${slug}/clone`, {}, authHeaders(token)).then((r) => r.data);

export const adminArchiveProduct = (token, slug, archived) =>
  axios.patch(`${API}/admin/products/${slug}/archive`, { archived }, authHeaders(token)).then((r) => r.data);
